import React from "react";

import { LayerDeleteAction, LayerDrawAction } from "fond/project/panels/InputPanel/actions";
import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";

import { useDesignEdits } from "../hooks/useDesignEdits";
import { useDesignRefinementActions } from "../hooks/useDesignRefinementActions";

/**
 * Stacked navigation panel for editing the drop assignments of a completed design.
 */
const DropAssignmentsRefinementPanel: React.FC = () => {
  const { hasDropAssignments } = useDesignEdits();
  const { editDropAssignments, deleteDropAssignments } = useDesignRefinementActions();

  return (
    <LayerPanel title="Drop assignments" layerKey="design-drop-assignments">
      <LayerDrawAction subtitle="Edit drop assignments on the map" onClick={editDropAssignments} />
      {hasDropAssignments && <LayerDeleteAction onDelete={deleteDropAssignments} />}
    </LayerPanel>
  );
};

export default DropAssignmentsRefinementPanel;
